import { Injectable, Injector } from '@angular/core';
import { VoucherReference } from '../entities/voucher-reference';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class VoucherReferenceService extends BaseCrudService<VoucherReference> {

  public uri = '/api/voucherReference/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance VoucherReferenceService');
  }

  buildSentence(entity?: VoucherReference, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = "";
      if (entity.voucherLedger) {
        query = query.concat(
          `voucherLedger.id${QueryOperator.Equal}${entity.voucherLedger.id}${QueryOperator.Split}`
        );
      }
      if (entity.voucherMain) {
        query = query.concat(
          `voucherMain.id${QueryOperator.Equal}${entity.voucherMain.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }

    //this.httpParams = this.httpParams.set(QueryOperator.SortParam, 'startContractDate');

    return this.httpParams;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/voucher-reference.service.ts